import { type PDPdownloadPdfFile, type ProductData, type PublicationDownloadFile } from "../../models/ProductData";
import { type SpecificationBandData } from "../dto/PdpPageProductDataDto";
import { type FootnoteDTO, type ImageDataDTO } from "../../dto/ProductDataDTO";
import { type ClusterItem } from "../../BearingSelectionAssistant/types";
import type { TechnicalInfoDataDTO } from "~/Search/dto/SearchResultsDTO";

export type PdpPageProductData = ProductData & {
  description: string;
  specificationBand: SpecificationBandData[];
  techImages: ImageDataDTO[];
  preferredProductsFamilyName: string;
  tracePartsOrderNo: string;
  tracePartsUrl: string;
  bearingXDesignation: string | null;
  mountingManagerURL: string;
  greaseAppUrl: string;
  footnotes: FootnoteDTO[];
  attributeIcons: ClusterItem[];
  commentsFootnotes: FootnoteDTO[];
  downloads: PDPdownloadPdfFile[];
  mountingPublicationsDownloads: PDPdownloadPdfFile[];
  publications: PublicationDownloadFile[];
  gpsdGroup: string | null;
  showBasicFrequencies: boolean | null;
  showRohsDownload: boolean;
  unitTag: UnitTagType;
  technicalInfo?: TechnicalInfoDataDTO;
};

export type PreferredProductData = Pick<
  ProductData,
  "designation" | "code" | "sapMaterialNumber" | "url" | "preferred" | "images" | "stockAmount"
>;

export type RelatedProductData = Pick<
  ProductData,
  | "designation"
  | "sapMaterialNumber"
  | "aliases"
  | "shortDescription"
  | "preferred"
  | "url"
  | "images"
  | "manufacturerLogoUrl"
  | "code"
  | "productAllCategories"
  | "quantityVisible"
>;

export enum UnitTagType {
  Metric = "TRUEMETRIC",
  Imperial = "TRUEIMPERIAL",
  Hybrid = "HYBRID",
}

const MAP = {
  TRUEMETRIC: UnitTagType.Metric,
  TRUEIMPERIAL: UnitTagType.Imperial,
  HYBRID: UnitTagType.Hybrid,
};

export function getUnitTagFromString(val?: string | null): UnitTagType {
  if (!val) {
    throw new Error("unit type cannot be null!");
  }
  const upperVal = val.toUpperCase() as keyof typeof MAP;
  const value = MAP[upperVal];
  if (!value) {
    throw new Error("unit type cannot be null!");
  }
  return value;
}
